import { Flex, Spacing } from '@billy/design-system'
import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../utils'
import { Line, Thumb } from './elements'
import * as Styled from './styles'
import { randomPercent } from './utils'

export type LoadingPlaceholderProps = {
  className?: string
  fullWidth?: boolean
  lines?: number
  withHeader?: boolean
  withThumb?: boolean
}

export const LoadingPlaceholder = ({
  className,
  fullWidth,
  lines = 2,
  withHeader,
  withThumb,
}: LoadingPlaceholderProps) => {
  const l = new Array(lines).fill(true)

  return (
    <Styled.PlaceholderContainer className={cc([className, reactClass('loading-placeholder')])}>
      {withThumb && (
        <Flex>
          <Thumb />
          <Flex width="80%" flexDirection="column" gap={Spacing.S12}>
            <Line width={randomPercent(80)} header={withHeader} />
            <Line width={randomPercent(60)} header={withHeader} />
          </Flex>
        </Flex>
      )}
      {!withThumb && withHeader && <Line width={randomPercent(80)} header={withHeader} />}
      {l.map((_, index) => (
        <Line key={index} width={fullWidth ? '100%' : randomPercent(60)} />
      ))}
    </Styled.PlaceholderContainer>
  )
}
